import { render, staticRenderFns } from "./Charges.vue?vue&type=template&id=5344e92a&scoped=true"
import script from "./Charges.vue?vue&type=script&lang=js"
export * from "./Charges.vue?vue&type=script&lang=js"
import style0 from "./Charges.vue?vue&type=style&index=0&id=5344e92a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5344e92a",
  null
  
)

export default component.exports